import React from 'react';

import { AuthProvider } from './auth';
import { OrderProvider } from './order';

const AppProvider: React.FC = ({ children }) => {
  return (
    <AuthProvider>
      <OrderProvider>{children}</OrderProvider>
    </AuthProvider>
  );
};

export default AppProvider;
